import { useState, useCallback } from "react";
import { useQuery } from "@tanstack/react-query";
import Axios from "Services/Auth/AxiosInterceptors";

// API caller
const fetchStateRestrictions = async (stateLimit = 50, page, search = "") => {
  const params = {
    stateLimit: 50,
    page,
    perPage: 20,
  };

  if (search) params.search = search;

  const response = await Axios.get(`/state-restriction/doctor/listing`, {
    params,
  });

  return response.data;
};

// Custom hook
export const useStateAccessLevels = (initialLimit = 50, searchedProvider = "") => {
  const [page, setPage] = useState(1);
  const [stateLimit, setStateLimit] = useState(initialLimit);

  const { data, isLoading, isError, refetch } = useQuery(
    ["stateRestrictions", stateLimit, page, searchedProvider],
    () => fetchStateRestrictions(stateLimit, page, searchedProvider),
    { keepPreviousData: true },
  );

  const pagination = data?.result?.result?.pagination;
  const goToNextPage = useCallback(() => {
    if (pagination?.hasNext) {
      setPage((prev) => prev + 1);
    }
  }, [pagination?.hasNext]);

  const goToPreviousPage = useCallback(() => {
    if (pagination?.hasPrevious) {
      setPage((prev) => Math.max(prev - 1, 1));
    }
  }, [pagination?.hasPrevious]);

  const setPageNumber = useCallback(
    (pageNumber) => {
      if (!pagination) {
        setPage(pageNumber);
        return;
      }

      const maxPage = pagination?.next ? pagination.next - 1 : pageNumber;
      const validPage = Math.min(Math.max(pageNumber, 1), maxPage);

      setPage(validPage);
    },
    [pagination],
  );

  return {
    data,
    isLoading,
    isError,
    stateLimit,
    setLimit: setStateLimit,
    page,
    hasNext: pagination?.hasNext ?? false,
    hasPrevious: pagination?.hasPrevious ?? false,
    goToNextPage,
    goToPreviousPage,
    setPageNumber,
    refetch,
  };
};
